// Use static public assets to avoid build-time type issues with imagetools query params
const heroBuildingXs = '/images/hero-building-sm.webp';
const heroBuildingSm = '/images/hero-building-sm.webp';
const heroBuilding = '/images/hero-building.webp';

const Hero = () => {
  return (
    <section className="relative flex flex-col overflow-hidden min-h-[53vh] md:min-h-[85vh]">
      {/* Background Image - LCP optimized: no fade-in delay */}
      <div className="absolute inset-0">
        {/* Fallback background color (only visible if image fails) */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1F4C6B] to-[#2a5d7f] -z-10" />
        <img 
          src={heroBuildingSm}
          srcSet={`${heroBuildingXs} 480w, ${heroBuildingSm} 768w, ${heroBuilding} 1536w`}
          sizes="100vw"
          alt="Edifício moderno de arquitetura contemporânea" 
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center 30%' }}
          fetchPriority="high" 
          decoding="async"
          loading="eager"
          width={1536}
          height={864}
        />
        {/* Desktop overlay */}
        <div 
          className="absolute inset-0 hidden md:block" 
          style={{
            background: 'linear-gradient(to bottom, rgba(4,18,30,0.35) 0%, rgba(4,18,30,0.18) 50%, rgba(4,18,30,0.28) 100%)'
          }} 
        />
        {/* Mobile overlay - stronger for readability */}
        <div 
          className="absolute inset-0 md:hidden" 
          style={{
            background: 'linear-gradient(to bottom, rgba(11,35,53,0.6) 0%, rgba(11,35,53,0.45) 50%, rgba(11,35,53,0.7) 100%)'
          }} 
        />
      </div>

      {/* Content - centered with flex-grow */}
      <div className="relative z-10 flex-1 flex items-center justify-center container mx-auto px-4 md:px-6 pt-16 md:pt-32 pb-6 md:pb-20">
        <div className="max-w-5xl mx-auto text-center font-raleway">
          {/* Headline */}
          <h1 
            className="font-serif font-extrabold animate-fade-up md:text-7xl md:leading-[1.08]" 
            style={{
              color: '#FFFFFF',
              textShadow: '0 2px 24px rgba(1, 22, 41, 0.35)',
              letterSpacing: '-0.02em',
              maxWidth: '18ch',
              margin: '0 auto',
              fontSize: 'clamp(34px, 8vw, 44px)',
              lineHeight: 1.02
            }}
          >
            Quando sua empresa é sua história, cada decisão conta
          </h1>

          {/* Subheadline */}
          <p 
            className="animate-fade-up mx-auto text-center mt-2 md:mt-6" 
            style={{
              animationDelay: "0.4s",
              color: 'rgba(255,255,255,0.88)',
              fontSize: 'clamp(14px, 2vw, 19px)',
              fontWeight: 500,
              lineHeight: 1.4,
              maxWidth: '38ch',
              textShadow: '0 2px 28px rgba(0,0,0,0.55), 0 1px 2px rgba(0,0,0,0.35)'
            }}
          >
            <span className="hidden md:inline" style={{ maxWidth: '54ch' }}>
              Apoiamos você em decisões estratégicas de M&A e finanças corporativas, transformando números em clareza para escolhas de longo prazo
            </span>
            <span className="md:hidden">
              M&A e finanças corporativas com clareza para decisões de longo prazo.
            </span>
          </p>

          {/* CTAs */}
          <div 
            className="flex flex-col gap-2 md:flex-row md:gap-4 justify-center items-center animate-fade-up mt-4 md:mt-7" 
            style={{ animationDelay: "0.5s" }}
          >
            {/* Primary Button */}
            <a 
              href="#servicos" 
              className="inline-flex items-center justify-center font-medium transition-all duration-300 hover:translate-y-[-2px] w-full md:w-auto" 
              style={{
                maxWidth: '300px',
                height: '46px',
                padding: '0 28px',
                backgroundColor: '#24567A',
                color: '#F4FFFF',
                border: '1px solid rgba(244,255,255,0.18)',
                boxShadow: '0 12px 28px rgba(4,18,30,0.28)',
                borderRadius: '12px',
                fontSize: '15px'
              }} 
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#215071';
                e.currentTarget.style.boxShadow = '0 16px 32px rgba(4,18,30,0.35)';
              }} 
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#24567A';
                e.currentTarget.style.boxShadow = '0 12px 28px rgba(4,18,30,0.28)';
              }}
            >
              Conheça nossos serviços
            </a>
            
            {/* Secondary Button - Ghost/Link style on mobile */}
            <a 
              href="#contato" 
              className="inline-flex items-center justify-center font-medium transition-all duration-300 w-full md:w-auto" 
              style={{
                maxWidth: '300px',
                height: '42px',
                padding: '0 24px',
                backgroundColor: 'transparent',
                color: 'rgba(255,255,255,0.9)',
                border: '1px solid rgba(255,255,255,0.35)',
                borderRadius: '12px',
                fontSize: '14px'
              }} 
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
              }} 
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.35)';
              }}
            >
              Fale Conosco
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - subtle, at very bottom */}
      <div 
        className="absolute bottom-3 left-1/2 -translate-x-1/2 z-10 md:hidden" 
        style={{ opacity: 0.4 }}
      >
      </div>
    </section>
  );
};

export default Hero;
